import { render, staticRenderFns } from "./AppStoreHeader.vue?vue&type=template&id=39306f4c"
import script from "./AppStoreHeader.vue?vue&type=script&lang=js"
export * from "./AppStoreHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports